import { FC } from 'react';

import { ColorDot } from '@purpur/library';

import { useTranslations } from '@telialt/common-cms/src/useTranslations';
import { getPurpurColor } from '@telialt/common-theme/src/purpurSelectors';
import { Stock } from '@telialt/models/src/EshopModel';
import { withParams } from '@telialt/utils/src/helpers';

import { ESHOP_TEST_ID } from '../test/test-ids';
import { ProductPreOrderStockStatusWrapper, StockSubtext } from './ProductStockStatus.styles';
import { getLocalizedStockShipmentDate } from './utils';

type Props = {
    stock: Stock;
};

export const ProductPreOrderStockStatus: FC<Props> = ({ stock }) => {
    const { t } = useTranslations();

    const localizedStockShipmentDate = getLocalizedStockShipmentDate(stock);

    return (
        <ProductPreOrderStockStatusWrapper data-test={ESHOP_TEST_ID.PRODUCT_PREORDER_STOCK_STATUS}>
            <ColorDot color={getPurpurColor('functionalBlack')} size="xs" />
            <div>{t['eshop.product_page.preorder.title']}</div>
            <StockSubtext>
                {withParams(t['eshop.product_page.preorder.description'], { date: localizedStockShipmentDate })}
            </StockSubtext>
        </ProductPreOrderStockStatusWrapper>
    );
};
